export default __webpack_public_path__ + "static/media/video-img.fac60cdc.png";